import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { peut, premierePage } from "../lib/permissions";

// `perm` : permission nécessaire (lib/permissions) ; sinon, on renvoie vers
// la première page à laquelle l'utilisateur a droit.
export function ProtectedRoute({ children, adminOnly = false, perm }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  const refuse = (adminOnly && !user.is_admin) || (perm && !peut(user, perm));
  if (refuse) {
    // d'abord une page permise de la même rubrique (ex. /colis), sinon la première permise
    const rubrique = "/" + (location.pathname.split("/")[1] || "");
    const p = (rubrique !== "/" && premierePage(user, rubrique)) || premierePage(user);
    if (p && p !== location.pathname) return <Navigate to={p} replace />;
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-2 text-center p-6">
        <p className="font-semibold">Aucune page n'est accessible avec votre compte.</p>
        <p className="text-sm text-muted-foreground">Demandez à un administrateur de vous donner des permissions.</p>
      </div>
    );
  }
  return children;
}
